import { render, staticRenderFns } from "./registration_link.vue?vue&type=template&id=46f32718&scoped=true&"
import script from "./registration_link.vue?vue&type=script&lang=js&"
export * from "./registration_link.vue?vue&type=script&lang=js&"
import style0 from "./registration_link.vue?vue&type=style&index=0&id=46f32718&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f32718",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46f32718')) {
      api.createRecord('46f32718', component.options)
    } else {
      api.reload('46f32718', component.options)
    }
    module.hot.accept("./registration_link.vue?vue&type=template&id=46f32718&scoped=true&", function () {
      api.rerender('46f32718', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/profile/registration_link.vue"
export default component.exports